export default {
    "autocomplete": "96583484407636ed80ec783b5ef48a7a709c90c7da312c00c6d1f438e00c5287",
    "autocompleteFind": "85f4610d1485562da524bf70f1eaf30f42b438d5f3c713272d6353254eaf3273",
    "retrieveAddress": "beef445e9f7a5c42172afe1a4dfcc8815a459d30af8440476aa2abd27af96bd1"
};
